import requestHandler from "./requestHandler";
export default {
  ...requestHandler,

  async loginPost(url, formData) {
    const plainFormData = Object.fromEntries(formData.entries());
    const formDataJsonString = JSON.stringify(plainFormData);
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
      },
      body: formDataJsonString,
    };
    const response = await fetch(url, fetchOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.error("Error", response);
    }
  },

  async me() {
    return await this.post("/api/me");
  },

  async getMenuByDate(date) {
    return await this.get(`/api/menu/${date}`);
  },

  async getTodaysMenu() {
    return await this.get("/api/menu");
  },

  async getLastMenu(limit = "") {
    const queryString = limit ? `?limit=${limit}` : "";
    return await this.get("/api/menu/last" + queryString);
  },

  async deleteMenu(date) {
    return await this.delete(`/api/menu/${date}`);
  },

  async getMonthMenus(year, month) {
    return await this.get(`/api/menu-list/${year}/${month}`);
  },

  async saveMenu(data) {
    return await this.put("/api/menu", data);
  },
};
